module.exports = " <div class=redactor-settings-wrapper> <select-fieldtype :name=name :data.sync=data :config=selectConfig></select-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/redactor/RedactorSettingsFieldtype.vue
// module id = 713
// module chunks = 0